import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Sets document title + Open Graph/Twitter meta tags for the current page.
export default function usePageMeta({ title, description, image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Our African Narratives` : "Our African Narratives · The Majesty of African History";
    document.title = fullTitle;
    const url = window.location.href;

    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "article");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    return () => {
      document.title = "Our African Narratives · The Majesty of African History";
    };
  }, [title, description, image]);
}
